import React from "react";
import classNames from "classnames";

import GoogleAd from "components/GoogleAd";

const DealsHero: React.FC<{ className?: string }> = ({ className }) => (
  <div
    className={classNames(
      className,
      "min-h-[210px] lg:min-h-[278px] flex items-center w-full",
    )}
  >
    <GoogleAd
      className="w-full"
      adPath="/13212770/product/category_hero"
      targeting={{
        "brand-expression": "true",
        "product-category": "deals",
      }}
    />
  </div>
);

export default DealsHero;
